<script lang="ts" setup>
import type { LocaleObject } from "@nuxtjs/i18n";

const { locale: currentLocale, locales } = useI18n();
const switchLocalePath = useSwitchLocalePath();

function safeSwitchLocalePath(locale: any) {
  // not all CMS pages have translations for all locales
  return switchLocalePath(locale) || `/${locale}`;
};

const items = computed(() => [locales.value
  .map((locale: LocaleObject) => {
    return {
      code: locale.code,
      label: locale.code!.substring(0, 2).toUpperCase(),
      to: `${safeSwitchLocalePath(locale.code)}`,
    };
  })]);
</script>

<template>
  <div>
    <div class="hidden lg:block">
      <UDropdownMenu
        :items="items"
        :ui="{ content: 'min-w-0 w-16', item: 'justify-center font-medium' }"
        :content="{ side: 'bottom', align: 'end' }"
      >
        <UButton
          variant="solid" color="primary" size="md" trailing-icon="i-ph-caret-down"
          :ui="{ base: 'bg-neutral-50 text-primary px-sm! py-xs! leading-6 hover:bg-neutral-50' }"
        >
          {{ currentLocale.substring(0, 2).toUpperCase() }}
        </UButton>
      </UDropdownMenu>
    </div>

    <div class="gap-md flex lg:hidden">
      <NuxtLink
        v-for="item of items.at(0)"
        :key="item.code"
        :to="item.to"
        :class="{
          'bg-[#F3F1EC]': item.code !== currentLocale,
          'bg-neutral-50': item.code === currentLocale,
        }"
        class="text-primary flex size-10 items-center justify-center rounded-full text-sm font-medium"
      >
        {{ item.label }}
      </NuxtLink>
    </div>
  </div>
</template>

<style>

</style>
